// extracted by mini-css-extract-plugin
module.exports = {"newsList":"NewsListPart_newsList__iYdvf","moreNews":"NewsListPart_moreNews__pZ7Aj"};